/* eslint-disable no-multi-assign */
/* eslint-disable keyword-spacing */
/* eslint-disable semi */
/* eslint-disable no-sequences */
/* eslint-disable one-var-declaration-per-line */
/* eslint-disable no-void */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
/* eslint-disable semi-spacing */
/* eslint-disable eqeqeq */
/* eslint-disable yoda */
/* eslint-disable no-return-assign */
/* eslint-disable no-shadow */
/* eslint-disable comma-spacing */
/* eslint-disable space-before-function-paren */
/* eslint-disable block-spacing */
/* eslint-disable no-var */
/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
/* eslint-disable one-var */
/* eslint-disable space-infix-ops */
/* eslint-disable quotes */
/* eslint-disable space-before-blocks */
/* eslint-disable no-undef */
/* eslint-disable prefer-template */
/* eslint-disable no-unused-expressions */
/* eslint-disable wrap-iife */
const POSTHOG_ENDPOINT = 'https://posthog.autobahn.security';
const POSTHOG_API_KEY = 'PkAAY1wLLlN1SVRQIzWlPaDkvHZyl3YJ-WjL_8Op668';

const TEST_POSTHOG_ENDPOINT = 'https://app.posthog.com';
const TEST_POSTHOG_API_KEY = 'QSXNb7lx-gTe6c6CkILvF5wJrsukPP1e2IUyR3uGY3w';

!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

if (window.location.hostname === 'autobahn.security') {
    posthog.init(POSTHOG_API_KEY, { api_host: POSTHOG_ENDPOINT });
} else {
    posthog.init(TEST_POSTHOG_API_KEY, { api_host: TEST_POSTHOG_ENDPOINT });
}
